'use strict';

class SuperDeveloperNotificationsController {
    constructor(SSUtilService, SSUserService, SSHttpService, OTPService, SSAlertService) {
        const self = this;

        self.SSUtilService = SSUtilService;
        self.SSUserService = SSUserService;
        self.SSHttpService = SSHttpService;
        self.OTPService = OTPService;
        self.SSAlertService = SSAlertService;

        self.data = SHOWSUITE.data;
        self.EMAIL_NOTIFICATION_SPA_DELIVERY_EXPIRY = SHOWSUITE.EMAIL_NOTIFICATION_SPA_DELIVERY_EXPIRY;
        self.EMAIL_NOTIFICATION_SPA_EXPIRY = SHOWSUITE.EMAIL_NOTIFICATION_SPA_EXPIRY;
        self.EMAIL_NOTIFICATION_OPTION_EXERCISED_SUMMARY = SHOWSUITE.EMAIL_NOTIFICATION_OPTION_EXERCISED_SUMMARY;
        self.EMAIL_NOTIFICATION_OPTION_EXERCISED = SHOWSUITE.EMAIL_NOTIFICATION_OPTION_EXERCISED;
        self.EMAIL_NOTIFICATION_OUTSTANDING_PROGRESSIVE_PAYMENTS = SHOWSUITE.EMAIL_NOTIFICATION_OUTSTANDING_PROGRESSIVE_PAYMENTS;

        self.developers = null;
        self.selectedDeveloper = null;
        self.developerSettings = null;
        self.developerSetting = null;

        self.const_dict_notifications = [
            {
                id:self.EMAIL_NOTIFICATION_SPA_DELIVERY_EXPIRY,
                value: "Email Notification SPA Delivery Expiry",
                check:false
            },
            {
                id:self.EMAIL_NOTIFICATION_SPA_EXPIRY,
                value: "Email Notification SPA Expiry",
                check:false
            },
            {
                id:self.EMAIL_NOTIFICATION_OPTION_EXERCISED_SUMMARY,
                value: "Email Notification Option Exercised Summary",
                check:false
            },
            {
                id:self.EMAIL_NOTIFICATION_OPTION_EXERCISED,
                value: "Email Notification Option Exercised",
                check:false
            },
            {
                id:self.EMAIL_NOTIFICATION_OUTSTANDING_PROGRESSIVE_PAYMENTS,
                value: "Email Notification Outstanding Progressive Payments",
                check:false
            }
        ];

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;
        self.getDevelopers();
    }

    getDevelopers(){
        let self = this;

        let url = 'developers/';

        loading(true);
        self.SSHttpService.getAPIRequest(url,{limit:1000}).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.developers = response.data.developers;
        });
    }

    getDeveloperSettings(){
        let self = this;

        let url = 'sec/developer/settings/';

        loading(true);
        self.SSHttpService.getAPIRequest(url,{developer_id: self.selectedDeveloper}).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.developerSettings = response.data.developer_settings;
            self.parseDeveloperSettings(self.developerSettings);
        });
    }

    developerSelected(){
        const self = this;
        self.getDeveloperSettings();
    }

    parseDeveloperSettings(developerSettings){
        const self = this;
        self.developerSetting = {
            developer_id : self.selectedDeveloper,
            name: "developer_email_notifications",
            value: ""
        };

        let confirm = false;

        developerSettings.find(element=>{
           if(element.name == 'developer_email_notifications'){
               self.developerSetting = angular.copy(element);
               confirm = true;
           }
        });

        if(confirm){
            let check = self.developerSetting.value.split(',');
            self.const_dict_notifications.forEach(val =>{
                if(jQuery.inArray(val.id.toString(),check) !== -1){
                    val.check = true;
                }
                else{
                    val.check = false;
                }
            });
        }
        else{
            self.const_dict_notifications.forEach(val =>{
                val.check = false;
            });
        }
    }

    convertDictToValue(){
        const self = this;
        self.developerSetting.value = "";
        self.const_dict_notifications.forEach(val =>{
            if(val.check) {
                if (self.developerSetting.value === "") {
                    self.developerSetting.value += (val.id);
                }
                else
                    self.developerSetting.value += ("," + val.id);
            }
        });
    }

    saveDeveloperSettings(){
        const self = this;

        if(!self.selectedDeveloper){
            return;
        }

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            self._saveDeveloperSettings();
        });
    }

    _saveDeveloperSettings(){
        const self = this;
        self.convertDictToValue();
        let url = 'sec/developer/settings/';
        let params = self.developerSetting;

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success(self.developers[self.selectedDeveloper].name + ' Settings has been saved successfully.');
        };

        loading(true);
        if (self.developerSetting.id) {
            url += self.developerSetting.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

}

SuperDeveloperNotificationsController.$inject = ['SSUtilService', 'SSUserService', 'SSHttpService','OTPService', 'SSAlertService'];
app.controller('SuperDeveloperNotificationsController', SuperDeveloperNotificationsController);